// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"55db1844","508":"d48df216","776":"dc471af0"}[chunkId] + ".chunk.js";
};